module.exports = __webpack_public_path__ + "img/2-7.5544abc2.png";